// eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
export function setTimeoutMockable(...params: Parameters<typeof setTimeout>) {
  // eslint-disable-next-line @typescript-eslint/no-implied-eval
  setTimeout(...params);
}
